import axios from "./axios";

export const downloadFile = async (url) => {

    try {

        const response = await axios.get(url, {
            responseType: "blob",
            // headers : {Accept : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}
        });

        let filename = "download.xlsx";

        const disposition = response.headers["content-disposition"];

        if (disposition && disposition.includes("filename=")) {
            filename = disposition.split("filename=")[1].split(";")[0].replace(/"/g, "");
        }

        const blob = new Blob([response.data]);
        const urlObject = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urlObject;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Cleanup
        link.remove();
        window.URL.revokeObjectURL(urlObject);

    } catch {

    }

}
